import BaseService from 'services/base'

export default class PendingActionService extends BaseService {
  constructor(api) {
    const url = 'pendingaction'
    super(api, url)
    this.api = api
    this.url = url
  }

  downloadOverdueInvoiceReport(url, payload, options) {
    return this.get(url, payload, { ...options, responseType: 'blob' })
  }
}
